import * as C from './styles';
import { Theme } from '../../components/Theme/intex';  // Correção do caminho do index
import { useForm, FormActions } from '../../context/FormContext';
import { useEffect, useState } from 'react';
import { ReactComponent as CheckIcon } from '../../svgs/check.svg';
import { useHistory } from 'react-router-dom';
import Modal from '../../components/Modal'; // Importando o componente Modal

export const FormStep3 = () => {
    const { state, dispatch } = useForm();
    const history = useHistory();
    const [modalMessage, setModalMessage] = useState('');
    const [redirect, setRedirect] = useState(false); // Novo estado para controlar o redirecionamento

    useEffect(() => {
        if (state.name === '') {
            history.push('/');  // Certifique-se de que o nome não está vazio antes de prosseguir.
        } else {
            dispatch({
                type: FormActions.setCurrentStep,
                payload: 3  // Atualizado para refletir o novo número do passo
            });
        }

        // Bloqueia navegação para os passos anteriores
        const unblock = history.listen((location, action) => {
            if ((location.pathname === '/step1' || location.pathname === '/step2') && action === 'POP') {
                history.push('/step3');
            }
        });

        return () => {
            unblock();
        };
    }, [history, state.name, dispatch]);

    const handleFinish = async () => {
        if (!state.hosts || state.hosts.length === 0) {
            setModalMessage('Nenhum host cadastrado para enviar mensagem.');
            return;
        }

        // Monta a mensagem com os hosts cadastrados
        const message = `Bem-vindo(a) ao IMS Network!\n\nHosts cadastrados:\n${state.hosts.map((host, index) => `${index + 1}. ${host.name} (${host.ip})`).join('\n')}\n\nObrigado por escolher nossa plataforma!\nhttps://imsnetwork.com.br/`;

        // Adiciona o prefixo 55 ao número de telefone
        const phoneNumber = `55${state.phone}`;

        // Verifica se as variáveis de ambiente estão definidas
        const url = process.env.REACT_APP_ULTRAMSG_URL;
        const token = process.env.REACT_APP_ULTRAMSG_TOKEN;
        if (!url || !token) {
            setModalMessage('Erro ao enviar mensagem: Configuração de ambiente não encontrada.');
            return;
        }

        // Envia a mensagem via API do UltraMsg
        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: new URLSearchParams({
                    token: token,
                    to: phoneNumber,
                    body: message
                }).toString()
            });
            const data = await response.json();
            console.log('Mensagem enviada:', data);
        } catch (error) {
            console.error('Erro ao enviar mensagem:', error);
            setModalMessage('Erro ao enviar mensagem de boas-vindas. Por favor, tente novamente mais tarde.');
            return;
        }

        setModalMessage('Cadastro concluído com sucesso! Você será redirecionado para a página inicial.');
        setRedirect(true); // Define que o redirecionamento deve ocorrer após fechar o modal

        // Limpar todos os formulários após concluir
        dispatch({ type: FormActions.setName, payload: '' });
        dispatch({ type: FormActions.setLevel, payload: 0 });
        dispatch({ type: FormActions.setEmail, payload: '' });
        dispatch({ type: FormActions.setGithub, payload: '' });
        dispatch({ type: FormActions.setCnpj, payload: '' });
        dispatch({ type: FormActions.setPhone, payload: '' });
        dispatch({ type: FormActions.setIp, payload: '' });
        dispatch({ type: FormActions.setOs, payload: 'Link' });
        dispatch({ type: FormActions.setHosts, payload: [] }); // Limpa a lista de hosts
    };

    const closeModal = () => {
        setModalMessage('');
        if (redirect) {
            history.push('/');
        }
    };

    return (
        <Theme>
            <C.Container>
                <h2>Parabéns {state.name}</h2>
                <p>Cadastro enviado com sucesso!</p>

                <C.IconArea>
                    <CheckIcon fill="rgb(0, 107, 219)" width={120} height={120} />
                </C.IconArea>

                <p className='check-email'>
                Será enviada uma notificação no whatsapp do nº: <b>{state.phone}</b><br /> 
                quando o host(s) estiver indisponível.<br /><br />
                Ao clicar em concluir não será possível retornar para cadastrar novos hosts.<br />
                Caso seja necessário cadastro de novo host,<br />
                por favor entre em contato com nosso setor comercial no email:<br />
                comercial@imsnetwork.com.br
                </p>

                <C.Button onClick={handleFinish}>Concluir</C.Button>

                {modalMessage && <Modal message={modalMessage} onClose={closeModal} />}
            </C.Container>
        </Theme>
    );
}
